// Room names that get static HTML (title/canonical/OG/H1 + seed body).
// Union of search index, hub links, and rooms with schedules on file.
var CasinoSearchArray = require('./casino-search-array');
var roomsWithSchedules = require('./rooms-with-schedules');
var metroHubs = require('./metro-hubs');
var stateHubs = require('./state-hubs');

function collectNames() {
  var set = {};

  (CasinoSearchArray || []).forEach(function(item) {
    var raw = String(item || '');
    var splitAt = raw.indexOf(': ');
    var name = splitAt > -1 ? raw.substr(0, splitAt) : raw;
    if (name) set[name] = true;
  });

  (roomsWithSchedules || []).forEach(function(name) {
    if (name) set[name] = true;
  });

  Object.keys(metroHubs || {}).forEach(function(slug) {
    (metroHubs[slug].rooms || []).forEach(function(room) {
      if (room && room.name) set[room.name] = true;
    });
  });

  Object.keys(stateHubs || {}).forEach(function(slug) {
    (stateHubs[slug].rooms || []).forEach(function(room) {
      if (room && room.name) set[room.name] = true;
    });
  });

  return Object.keys(set).sort(function(a, b) {
    return a.toLowerCase().localeCompare(b.toLowerCase());
  });
}

module.exports = collectNames();



// WEBPACK FOOTER //
// ./js/rooms-to-prerender.js